<template lang="html">
  <div>
    <b-row
      v-for="song in $store.state.song_query_results"
      :key="'grid-' + song.id"
      md="4"
      class="mb-5"
    >
      <b-col md="4">
        <a
          :href="`https://www.youtube.com/watch?v=${song.youtube_id}`"
          target="_blank"
        >
          <b-img thumbnail :src="song.thumbnail.url" />
        </a>
      </b-col>

      <b-col md="5">
        <h3 v-text="song.title" />

        <p>
          <span
            v-for="(chord, idx) in song.chord_array"
            :key="chord + song.id + '_' + idx"
            @click="$store.dispatch('toggleKnownChord', chord)"
          >
            <ChordDiagram
              v-if="$store.state.chordDataLoaded && displayChord(chord)"
              :chord="chord"
              :fill-color="returnFillColor(chord)"
              :small="true"
            />
          </span>
        </p>
        <div>
          <b-button
            :href="`https://www.youtube.com/watch?v=${song.youtube_id}`"
            variant="secondary"
            target="_blank"
            class="mr-1"
          >
            <v-icon name="external-link-alt" class="mr-1" /> View
          </b-button>

          <!-- Favorite -->
          <b-btn
            v-show="$store.state.favorite_song_ids.includes(song.id)"
            variant="outline-danger"
            class="favorite mr-1"
            @click="$store.dispatch('toggleFavorite', song)"
          >
            <v-icon name="heart" />
          </b-btn>
          <!-- Not favorite -->
          <b-btn
            v-show="!$store.state.favorite_song_ids.includes(song.id)"
            class="mr-1"
            @click="$store.dispatch('toggleFavorite', song)"
          >
            <v-icon name="heart" />
          </b-btn>
        </div>
      </b-col>
      <b-col md="3">
        <!-- PlayAlongs -->
        <p v-if="song.content == 'playalong'" class="small">
          Play-along video by
          <b-link
            :to="{
              name: 'all',
              query: { search: song.youtube_channel_id },
              params: {
                tuning: $store.getters.ukeTuning
              }
            }"
            v-text="song.youtube_data.channelTitle"
          />.
        </p>
        <!-- Tutorial -->
        <p v-if="song.content == 'tutorial'" class="small">
          Tutorial video by
          <b-link
            :to="{
              name: 'all',
              query: { search: song.youtube_channel_id },
              params: {
                tuning: $store.getters.ukeTuning
              }
            }"
            v-text="song.youtube_data.channelTitle"
          />.
        </p>
        <p v-if="song.original_metadata_added" class="small">
          <span class="text-muted">Based on the track </span>
          <em>
            <b-link
              :to="{
                name: 'all',
                query: { search: song.original_track_title },
                params: {
                  tuning: $store.getters.ukeTuning
                }
              }"
              v-text="song.original_track_title"
            />
          </em>
          from
          <b-link
            :to="{
              name: 'all',
              query: { search: song.original_artist_name },
              params: {
                tuning: $store.getters.ukeTuning
              }
            }"
            v-text="song.original_artist_name"
          />.
        </p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ChordDiagram from "@/components/ChordDiagram";
export default {
  name: "ThumbList",
  components: {
    ChordDiagram
  },
  methods: {
    displayChord(chordName) {
      if (!this.$store.state.userPreferences.hideKnownChordShapes) {
        return true;
      }
      if (this.$store.getters.knownChords.includes(chordName)) {
        return false;
      }
      return true;
    },

    returnFillColor(chordName) {
      if (this.$store.getters.knownChords.includes(chordName)) {
        return "green";
      }
      return "black";
    }
  }
};
</script>

<style lang="scss" scoped>
.song-card {
  position: relative;
  height: 100%;
  padding-bottom: 40px;
  .card-title {
    font-size: 1.2em;
  }
}
.card-bottom {
  position: absolute;
  bottom: 0px;
}
</style>
